export const ID = '3534c707-1f57-4962-849e-7b51c69c9804';

export const NAME = 'Google Map: One Facility';
